import { Fragment, type ReactElement, useState } from "react"

import { useTranslation } from "react-i18next"

import { Grid } from "@mui/material"
import { Button, Typography } from "@synapse-analytics/synapse-ui"

import type { SelectedComponent } from "../Interfaces"
import { ComponentTestingCanvas } from "./ComponentTestingCanvas"
import { ComponentTestingCreation } from "./ComponentTestingCreation"

import styles from "./ComponentTesting.module.scss"

export const ComponentTesting = (): ReactElement => {
  const { t } = useTranslation("predictions", {
    keyPrefix: "componentTesting",
  })

  const [selectedComponent, setSelectedComponent] = useState<SelectedComponent | null>(null)
  const [step, setStep] = useState<1 | 2>(1)

  const handleNext = (): void => {
    if (step === 1 && selectedComponent) {
      setStep(2)
    }
  }

  const renderStep = (): JSX.Element | null => {
    switch (step) {
      case 1:
        return (
          <Grid className={styles.root}>
            {/* Header */}
            <Grid className={styles.header}>
              <Typography variant="label-bold">{t("header.description")}</Typography>
            </Grid>
            <Grid container flexDirection="column" className={styles.workflowPath}>
              <Grid className={styles.canvasHeader}>
                <Typography variant="label-bold">{t("workflowPath.title")}</Typography>
              </Grid>
              <Grid item className={styles.canvasContainer}>
                <ComponentTestingCanvas
                  selectedComponent={selectedComponent}
                  setSelectedComponent={setSelectedComponent}
                />
              </Grid>
            </Grid>
            <Grid container item className={styles.actions} justifyContent="flex-end" gap={2}>
              {step === 1 && (
                <Button variant="primary" onClick={handleNext} disabled={step === 1 && !selectedComponent}>
                  {t("actions.next")}
                </Button>
              )}
            </Grid>
          </Grid>
        )
      case 2:
        return <ComponentTestingCreation selectedComponent={selectedComponent as SelectedComponent} />
      default:
        return null
    }
  }

  return <Fragment>{renderStep()}</Fragment>
}
